<template>
    <RegularModal ref="modal">
        <template v-slot:title>{{ translate("admin_share_brackets.title") }}</template>
        <template v-slot:body>
            <div v-if="store.sharing">
                <p class="mb-4">{{ translate("admin_bracket_listing.share_brackets_info") }}</p>

                <p class="mb-4">
                    <span class="has-text-grey-light mr-2">{{ translate("admin_share_brackets.current_status") }} </span>
                    <span class="tag" :class="store.sharing.enabled ? 'is-success' : 'is-danger'">
                        {{ store.sharing.enabled ? translate("common.enabled") : translate("common.disabled") }}
                    </span>
                </p>

                <div v-if="store.sharing.enabled">
                    <p class="has-text-grey-light">{{ translate("admin_share_brackets.address") }}</p>
                    <a :href="store.sharing.publicUrl" target="_blank" rel="noopener">{{ store.sharing.publicUrl }}</a>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="buttons">
                <button class="button" @click="close">{{ translate("common.close") }}</button>
                <LoadingButton
                    v-if="store.sharing"
                    :is-loading="saving"
                    class="button"
                    :class="store.sharing.enabled ? 'is-danger' : 'is-success'"
                    @click="toggleSharing"
                >
                    <span class="icon">
                        <i class="fas" :class="store.sharing.enabled ? 'fa-times' : 'fa-share-square'"></i>
                    </span>
                    <span>
                        {{
                            store.sharing.enabled
                                ? translate("admin_bracket_listing.share_brackets_disable")
                                : translate("admin_share_brackets.title")
                        }}
                    </span>
                </LoadingButton>
            </div>
        </template>
    </RegularModal>
</template>

<script setup lang="ts">
    import { ref } from "vue";
    import RegularModal from "../../Common/RegularModal.vue";
    import LoadingButton from "../../Common/LoadingButton.vue";
    import { translate } from "../../Common/translations";
    import { handleError } from "../../Common/errorHandler";
    import { successToast } from "../../Common/toasts";
    import { useModal } from "../../Common/useModal";
    import { useBracketsListingStore } from "./bracketsListingApp";

    const store = useBracketsListingStore();
    const saving = ref(false);

    const { modal, open, close } = useModal();

    function toggleSharing() {
        if (!store.sharing) {
            return;
        }

        const enable = !store.sharing.enabled;
        saving.value = true;
        store
            .updateBracketsSharing(enable)
            .then(() => {
                successToast(
                    translate(
                        enable
                            ? "admin_bracket_listing.share_brackets_enabled_toast"
                            : "admin_bracket_listing.share_brackets_disabled_toast",
                    ),
                );
            })
            .catch(handleError)
            .finally(() => {
                saving.value = false;
            });
    }

    defineExpose({ open });
</script>

<style scoped></style>
